import * as React from 'react';
import { GhostCalendarViewModel } from '../../../../viewmodels/AdminViewModels';
import { ISelectedGhostCalendarFilterOptions } from './models';

export interface IGhostCalendarContext {
	ghostCalendar: GhostCalendarViewModel;
	selectedFilterOptions: ISelectedGhostCalendarFilterOptions;
	setSelectedFilterOptions(filterOptions: ISelectedGhostCalendarFilterOptions): Promise<void>;
}

export const GhostCalendarContext = React.createContext<IGhostCalendarContext>(null);

export const useGhostCalendar = () => {
	const context = React.useContext(GhostCalendarContext);
	if (!context) {
		throw new Error('useGhostCalendar can only be used within the <GhostCalendar /> component');
	}
	return context;
};
